const ADNOC_ILT_SERVICE_URL = "/services/plugin-adnoc-ilt/config"
const ANNOTATIONS_SERVICE_URL = '/services/plugin-annotations/annotations'

export const getExpression = (signal, company) => fetch(`${ADNOC_ILT_SERVICE_URL}/expression/${company}`, { signal })
export const getTemplate = (signal, company) => fetch(`${ADNOC_ILT_SERVICE_URL}/template/${company}`, { signal })

export const saveExpression = (company, payload: {expression: string}) =>
    fetch(`${ADNOC_ILT_SERVICE_URL}/expression/${company}`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })


export const getPrograms = (signal, company) => fetch(`${ADNOC_ILT_SERVICE_URL}/programs/${company}`, { signal })
export const getActivities = (signal, company, programName) => fetch(`${ADNOC_ILT_SERVICE_URL}/activities/${company}/${programName}`, { signal })
export const getSubActivities = (signal, company, programName) => fetch(`${ADNOC_ILT_SERVICE_URL}/subactivities/${company}/${programName}`, { signal })

export const getConfigByWellId = (signal, wellId) => fetch(`${ADNOC_ILT_SERVICE_URL}/${wellId}`, { signal })
export const saveConfigByWellId = (wellId: string, payload: Map<String,String>) =>
    fetch(`${ADNOC_ILT_SERVICE_URL}/${wellId}`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })

export const getSections = (signal, interventionId) => fetch(`/services/plugin-liverig/assets/intervention/${interventionId}/part/drilling_sections`, { signal });

export const saveSections = (interventionId, payload) => fetch(`/services/plugin-liverig/assets/intervention/${interventionId}/part/drilling_sections`, {
  method: "POST",
  headers: {
    "content-type": "application/json",
  },
  body: JSON.stringify(payload)
});

export const getRunPath = (signal, wellName, span) => fetch(`/services/plugin-run-parameters/parameters/runpath/${wellName}/${span}`, { signal })

export const getInterventionsTree = (signal, wellName) => fetch(`/services/plugin-drilling-operations-span-picker/tree/${wellName}/plugin-drilling-operations-span-picker`, { signal });

export const getInterventions = (signal, wellId) => fetch(`services/plugin-liverig/assets/well/view/intervention/${wellId}`, { signal });

export const createAnnotation = (payload) => fetch(ANNOTATIONS_SERVICE_URL, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
})

export const getLookupTable = (signal, lookup_key) => fetch(`/rest/lookup/${lookup_key}`, { signal }).then(r => {
    if (r.ok) {
        return r.json()
    } else {
        return Promise.reject(`Could not find lookup "${lookup_key}"`)
    }
})

export const getMetadataAnnotations = (signal, wellName, span) => fetch(`/services/plugin-adnoc-ilt/metadata/${wellName}/${span}`, { signal })

export default {
    getExpression,
    getTemplate,
    saveExpression,
    getPrograms,
    getActivities,
    getSubActivities,
    getConfigByWellId,
    saveConfigByWellId,
    getSections,
    saveSections,
    getRunPath,
    getInterventions,
    getInterventionsTree,
    createAnnotation,
    getLookupTable,
    getMetadataAnnotations
}
